import { SkeletonType } from '@/shared/types/layoutTypes';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Container from '../Container/Container';

export const FilterSkeleton = (props: SkeletonType) => {
    const { items } = props;

    return (
        <Container code="standard">
            {Array.from({ length: items }, (_, index) => (
                <Skeleton style={{ marginBottom: '20px' }} key={index} height={26} />
            ))}
        </Container>
    );
};
